import React from 'react';
import { IonButton, IonContent, IonPage } from '@ionic/react';
import { Calendar, CalendarOptions } from '@ionic-native/calendar';

interface EventInterface {
  id: number;
  title: string;
  location: string;
  message: string;
  startDate: string;
  endDate: string;
}

interface CalendarInterface {
  id: number;
  name: string;
  displayName: string;
  isPrimary: boolean;
}

interface ComponentProps {
}

interface ComponentState {
  readWrite: boolean;
  events: Array<EventInterface>;
  calendars: Array<CalendarInterface>;
  selectedCalendar: number;
}

export default class Testing extends React.Component<ComponentProps, ComponentState> {

  private calOptions: CalendarOptions | undefined;

  state = {
    readWrite: false,
    events: [],
    calendars: [],
    selectedCalendar: 1
  }

  componentDidMount() {
    console.log('--- asking read/write permission')
    Calendar.hasReadWritePermission().then(result => {
      console.log('--- Got result: ' + result);
      this.setState({readWrite: result});
      if (result) {
        this.listCalendars();
        setTimeout(() => {
          this.calOptions = Calendar.getCalendarOptions();
          // this.calOptions.calendarName = 'hakan.djarv@gmail.com';
          // this.calOptions.calendarId = 3;
          this.findEvents();
        }, 500);
      } else {
        Calendar.requestReadPermission();
      }
    }, error => {
      console.log('--- error asking permission: ' + error)
    }).catch(err => {
      console.log('--- error caubht: ' + err);
    });
  }

  private listCalendars = () => {
    Calendar.listCalendars().then((cals: Array<CalendarInterface>) => {
      const calendars: Array<CalendarInterface> = [];
      for (const cal of cals) {
        console.log('--- Found cal: ' + JSON.stringify(cal));
        if (cal.isPrimary) {
          calendars.push(cal);
        }
      }
      this.setState({calendars: calendars})
    })
  }

  private addEvent = () => {
    // ios only
    // Calendar.createCalendar('Walking Talking').then(result => {
    //   console.log(result);
    // })
    const title = "Promenad";
    const eventLocation = "Hemma";
    const notes = "Vi ska gå fort som fan";
    const startDate = new Date(2020, 8, 7, 18, 30);
    const endDate = new Date(2020, 8, 7, 19, 30);
    Calendar.createEventWithOptions(title,eventLocation,notes,startDate,endDate,this.calOptions).then(
      (msg) => {
        console.log('created event: ', JSON.stringify(msg));
      }, (err) => {
        console.log('created err: ', err)
    }).catch(reason => {
      console.log('----- fail:', reason);
    });
    console.log('----- added calendar event?');
  }


  private findEvents = () => {

    const title = "Promenad";
    const eventLocation = "Hemma";
    const notes = "Vi ska gå fort som fan";
    const startDate = new Date(2020, 8, 5, 18, 30);
    const endDate = new Date(2020, 8, 5, 19, 30);
    console.log('--- findEvent');
    Calendar.findEvent(title,eventLocation,notes,startDate,endDate).then((msg) => {
      console.log('Find events: ' + msg.length);
      const eventList: Array<EventInterface> = [];
      for (const event of msg) {
        console.log(JSON.stringify(event));
        eventList.push(event);
      }
      this.setState({events: eventList});
    }, (err) => {
      console.log(err)
    })
  }


  private deleteEvent = (id: number) => {
    const idStr = id + '';
    console.log('--- Deleting ' + idStr);
    Calendar.deleteEventById(idStr).then(result => {
      console.log('--- deleted event ' + idStr);
      this.findEvents();
    }, error => {
      console.log('--- could not delete: ' + error)
      this.findEvents();
    }).catch(err => {
      console.log('--- err: ' + err);
    });
  }

  private openCalendar = () => {
    const now = new Date();
    Calendar.openCalendar(now).then(result => {
      console.log('Got calendars:', result);
    });
  }

  render() {
    if (!this.state.readWrite) {
      return (
        <div className="mt-8">
          No read/write permission to calendar
        </div>
      )
    }
    return (
      <IonPage className="cheap_desktop">
        <IonContent>
          <div className="mx-4">
            <h1 className="mt-8">Testsidan</h1>
            <IonButton className="text_center mt-8" onClick={() => this.addEvent()}>Lägg till event</IonButton>
            <IonButton className="text_center mt-8" onClick={() => this.findEvents()}>Lista events</IonButton>
            <IonButton className="text_center mt-8" onClick={() => this.openCalendar()}>Öppna kalender</IonButton>

            {
              this.state.events.map((event: EventInterface) => {
                return (
                  <div key={"event_" + event.id} className="mt-4">
                    <p>{event.title}</p>
                    <p>Message: {event.message}</p>
                    <p>{event.startDate} - {event.endDate}</p>
                    <p onClick={() => this.deleteEvent(event.id)}>Radera</p>
                  </div>
                )
              })
            }

            {
              this.state.calendars.map((calendar: CalendarInterface) => {
                return (
                  <div key={"calendar_" + calendar.id} className="mt-4">
                    <p>{calendar.name}</p>
                    <p>Calendar id: {calendar.id}</p>
                  </div>
                )
              })
            }
          </div>

        </IonContent>
      </IonPage>
    );
  }
}
